import * as React from "react"
import BroadcastChannel from "broadcast-channel"

function useSyncedState<S = any>(
	channel: BroadcastChannel<S>,
	initialState: S | (() => S)
) {
	const [state, mainSetState] = React.useState<S>(initialState)

	channel.onmessage = mainSetState

	const setState = React.useCallback<React.Dispatch<S>>(
		(state) => {
			channel.postMessage(state)
			mainSetState(state)
		},
		[channel, mainSetState]
	)

	return [state, setState, mainSetState] as const
}

export default useSyncedState
